namespace $.$$ {
	export class $shm_hitalama_quick_item extends $.$shm_hitalama_quick_item {
		
		transition(): string {
			return this.dragged() ? super.transition() : this.transition_smooth()
		}
		
	}
}
